import { render, staticRenderFns } from "./ReleaseNotesModal.vue?vue&type=template&id=44bff274&scoped=true"
import script from "./ReleaseNotesModal.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesModal.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesModal.vue?vue&type=style&index=0&id=44bff274&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bff274",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44bff274')) {
      api.createRecord('44bff274', component.options)
    } else {
      api.reload('44bff274', component.options)
    }
    module.hot.accept("./ReleaseNotesModal.vue?vue&type=template&id=44bff274&scoped=true", function () {
      api.rerender('44bff274', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaModal/ReleaseNotesModal.vue"
export default component.exports